import { Grid, Paper, Typography } from "@mui/material";
import CardImage from "@/components/cardImage";
import { PurchaseResultTravel } from "@t3/shared";

interface CartHistoryTravelItemProps {
  product: PurchaseResultTravel;
}

export const CartHistoryTravelItem = ({
  product,
}: CartHistoryTravelItemProps) => {
  return (
    <Paper
      elevation={2}
      sx={{
        margin: "16px 0",
        padding: 2,
        borderRadius: 1.5,
      }}
      key={product.travelProduct.utid}
      data-cypress={`history-travel-item`}
    >
      <Grid container spacing={2} direction={{ xs: "column", sm: "row" }}>
        {/* Product Image */}
        <Grid size={{ xs: 12, sm: 3, md: 2 }}>
          <div
            style={{
              width: "100%",
              maxWidth: "180px",
              margin: "0 auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              borderRadius: "6px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            }}
            data-cypress="travel-item-image-container"
          >
            <CardImage
              imageUrl={product.travelProduct.metadata.imageUrls.firebaseImage}
              margin={{ xs: "5px 5px 0 3px", sm: "auto" }}
              width="100%"
              height="auto"
            />
          </div>
        </Grid>

        {/* Product Details */}
        <Grid size={{ xs: 12, sm: 9, md: 10 }}>
          {/* Product Title */}
          {`$${product.travelProduct.amount} - ${product.travelProduct.metadata.brandName}`}
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              color: "#1a1a1a",
              mb: 1,
              lineHeight: 1.2,
            }}
            data-cypress="travel-item-title"
          >
            {`$${product.travelProduct.amount} -  `}
            {product.travelProduct.metadata.brandName}
          </Typography>

          {/* Delivery Email Address */}
          {product.email ? (
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                color: "#555",
                fontWeight: 500,
              }}
              data-cypress="travel-item-delivery-email"
            >
              Delivery email address:{" "}
              <span
                style={{ fontWeight: "normal" }}
                data-cypress="travel-item-email-value"
              >
                {product.email}
              </span>
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                color: "#555",
                fontWeight: 500,
              }}
              data-cypress="travel-item-delivery-email-error"
            >
              Delivery email address:{" "}
              <span style={{ fontWeight: "normal" }}>
                Not available due to error
              </span>
            </Typography>
          )}

          {/* Error display for items with 0 points */}
          {product.pointsCost === 0 && (
            <Typography
              variant="caption"
              sx={{
                color: "#d32f2f",
                p: 1,
                bgcolor: "rgba(211, 47, 47, 0.05)",
                borderRadius: 1,
                border: "1px solid rgba(211, 47, 47, 0.1)",
                fontWeight: "normal",
                mt: 1,
                display: "block",
              }}
              data-cypress="travel-item-error-message"
            >
              An error occurred on this purchase. Your points have been
              refunded. Try purchasing this product again.
            </Typography>
          )}

          {/* Points (no Reference ID for travel items) */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              flexWrap: "wrap",
              gap: "8px",
              marginTop: 10,
            }}
          >
            <div></div>{" "}
            {/* Empty div to maintain layout when no reference ID is shown */}
            <Typography
              variant="body2"
              sx={{ fontWeight: 500 }}
              data-cypress="travel-item-points"
            >
              Points:{" "}
              <span
                style={{ color: "#d32f2f", fontWeight: "bold" }}
                data-cypress="travel-item-points-value"
              >
                {product.pointsCost}
              </span>
            </Typography>
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};
